import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/rem'
// import './assets/js/jweixin-1.4.0'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/qc.css'
import '@/icons' // icon
import VueI18n from 'vue-i18n'
import I18nInit from "@/i18n/index"

import { languageGet } from "@/api/languages"
import {
    Button,
    Swipe,
    SwipeItem,
    Lazyload,
    Tag,
    Field,
    CountDown,
    Form,
    SwipeCell,
    Badge,
    Dialog,
    CellGroup,
    ImagePreview,
    Uploader,
    Grid,
    Area,
    GridItem,
    PullRefresh,
    Search,
    Tab,
    Tabs,
    Tabbar,
    TabbarItem,
    DropdownMenu,
    DropdownItem,
    Popup,
    RadioGroup,
    DatetimePicker,
    Radio,
    Toast,
    Slider,
    Collapse,
    CollapseItem,
    Overlay,
    Icon,
    Picker,
    Loading,
    List,
    Checkbox,
    Popover,
    TreeSelect,
    image,
    NoticeBar,
    ActionSheet
} from 'vant'

Vue.use(ElementUI)
Vue.use(Button)
    .use(ActionSheet)
    .use(Icon)
    .use(Loading)
    .use(Swipe)
    .use(SwipeItem)
    .use(DatetimePicker)
    .use(Area)
    .use(Collapse)
    .use(CollapseItem)
    .use(SwipeCell)
    .use(Lazyload)
    .use(Badge)
    .use(Tag)
    .use(Field)
    .use(CountDown)
    .use(Form)
    .use(Tab)
    .use(Tabs)
    .use(Dialog)
    .use(List)
    .use(CellGroup)
    .use(Uploader)
    .use(Overlay)
    .use(Picker)
    .use(Grid)
    .use(GridItem)
    .use(PullRefresh)
    .use(Search)
    .use(Tabbar)
    .use(TabbarItem)
    .use(DropdownMenu)
    .use(DropdownItem)
    .use(Popup)
    .use(RadioGroup)
    .use(Radio)
    .use(Toast)
    .use(Checkbox)
    .use(Slider)
    .use(Popover)
    .use(TreeSelect)
    .use(image)
    .use(NoticeBar)
    .use(VueI18n)

// request interceptor
require('./utils/request.js')
require('./utils/imRequest.js')
require('./utils/uploadRequest.js')
require('./components/diretive')

import animate from 'animate.css'

Vue.use(animate);

Vue.config.productionTip = false;
Vue.prototype.$Toast = Toast;
Vue.prototype.$ImagePreview = ImagePreview;

let localeLanguages = 'cxo';

// console.log(localData);
const localData = {
    ifus: require('@/assets/languages/ifus.json'),
    cxo: require('@/assets/languages/cxo.json'),
    en: require('@/assets/languages/en.json'),
}
Toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true,
    message: localData[localeLanguages].comonTxt.loadTxt,
});

Vue.directive('Alphabet', {
    inserted: function(el) {
        const input = el.getElementsByTagName('input')[0];
        input.onkeyup = function(e) {
            input.value = input.value.replace(/[^A-Za-z0-9]/g, '')
        }
        input.onblur = function(e) {
            input.value = input.value.replace(/[^A-Za-z0-9]/g, '')
        }
    }
});

store.dispatch('user/getInfo').then(async(resData) => {
    let languagesData = await languageGet();
    localeLanguages = languagesData.data.data.language || 'cxo';
    console.log(localeLanguages);
    localStorage.setItem("language", localeLanguages)
    const i18n = I18nInit(localeLanguages)
        // const i18n = new VueI18n({
        //     locale: localeLanguages,
        //     messages: {
        //         // 'cxo': languagesData.data.data,
        //         'cxo': localData['cxo'],
        //         'ifus': localData['ifus'],
        //         'en': localData['en']
        //     }
        // })
    await new Vue({
        router,
        store,
        i18n,
        render: (h) => h(App)
    }).$mount('#app')
    Toast.clear();
})